<template>
    <div>
        <Flash ref="show"/>

        <Flash ref="upload-show" :width="400">
            <table class="upload-table">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(file, f) in uploadedFiles" :key="f">
                        <td>{{ file.name }}</td>
                        <td>
                            <i v-if="file.perc">{{ file.perc }}%</i>
                        </td>
                        <td>
                            <LoaderAnimationVue v-if="file.state == 'progress'" color="#fff" size="10px"/>
                            <i v-else-if="file.state == 'failed'" class="icon-close-outline"></i>
                            <i v-else-if="file.state == 'done'" class="icon-checkmark-outline"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="hidden">{{ uploadingInProcess }}</div>
        </Flash>
    </div>
</template>

<script>
import {api} from "@/mixins/axios";
import Flash from "@/components/Flash.vue";
import LoaderAnimationVue from "@/components/atoms/LoaderAnimation.vue";

export default {
    name: "UploadingStatus",
    components: {
        Flash,
        LoaderAnimationVue
    },
    data() {
        return {
            uploadedFiles: null,
            uploadLimit: 300,
            chunkSize: 2 * 1024 * 1024,
        };
    },
    computed: {
        uploadingInProcess() {
			return this.$store.getters.uploadingInProcess
		}
    },
    methods: {
        calcPercentage(current, total) {
            return Math.floor(current * 100 / total)
        },
        initialUploading() {
            this.$refs['upload-show'].showFlashForever();
            this.uploadedFiles = []
        },
        async uploading() {
            console.log('uploading')
            let index = 0;
            
            for(index; index < this.uploadedFiles?.length; index++) {
                const file = this.uploadedFiles[index]
                if (file.size > this.uploadLimit * 1024 * 1024) {
                    this.$refs['upload-show'].showFlashError(`Files bigger than ${this.uploadLimit}MB are not allowed.`);
                    this.uploadedFiles[index]['state'] = 'failed'
                    continue
                }

                this.uploadedFiles[index]['state'] = 'progress'
                this.uploadedFiles[index]['perc'] = 0

                const totalChunks = Math.ceil(file.size / this.chunkSize);
                let start = 0;
                let fileSent = false
                const uniqueUUID = Date.now()
                this.$store.dispatch('setUploadingState', {total: totalChunks, current: 0, file: file})

                for (let chunkNumber = 1; chunkNumber <= totalChunks; chunkNumber++) {
                    this.$store.dispatch('setUploadingState', {total: totalChunks, current: chunkNumber, file: file})
                    this.uploadedFiles[index]['perc'] = this.calcPercentage(chunkNumber, totalChunks)
                    console.log(this.uploadedFiles[index])
                    const end = Math.min(start + this.chunkSize, file.size);
                    const chunk = file.slice(start, end);
                    const newFile = new File([chunk], file.name, { type: chunk.type })
                    const formData = new FormData();
                    console.log(newFile)
                    formData.append('file', newFile);
                    formData.append('dztotalfilesize', file.size);
                    formData.append('dzchunkindex', chunkNumber - 1);
                    formData.append('dztotalchunkcount', totalChunks);
                    formData.append('dzuuid', uniqueUUID);

                    try {
                        const response = await api.post(`/task_upload/${file.taskID}`, formData, {
                            headers: { "Content-Type": "multipart/form-data" },
                        });
                        if(response.data.msg === 'Chunk received') {
                            fileSent = true
                        }
                        start = end;
                    } catch (e) {
                        console.log(e);
                        fileSent = false
                        this.$store.dispatch('setUploadingState', null)
                        chunkNumber = totalChunks;
                        this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || 'Something went wrong')
                        if(e.response.status === 402) {
                            this.$store.dispatch('updatePlanLimit', 'uploading files');
                        }
                    }
                }

                if(fileSent) {
                    this.uploadedFiles[index]['state'] = 'done'
                    fileSent = false
                } else {
                    this.uploadedFiles[index]['state'] = 'failed'
                }
            }

            if(index == this.uploadedFiles?.length) {
                this.$refs.show?.showFlashSuccess(`Uploaded`);
                this.$store.dispatch('setUploadingState', -1)

                setTimeout(() => {
                    this.uploadedFiles = null
                    this.$refs['upload-show'].hideFlash();
                }, 2000);
                this.$forceUpdate()
            }
        },
        async init(files, taskID) {
            if(!this.uploadedFiles) {
                this.initialUploading()
                for(let i = 0; i < files.length; i++) {
                    files[i]['taskID'] = taskID
                    this.uploadedFiles.push(files[i])
                }
            }
            this.uploading()
        }
    }
};
</script>

<style lang="scss">
</style>
